import { digitalmenuReducer } from 'store/reducers';
import { combineReducers } from 'redux';

export const rootReducer = combineReducers({
  digitalmenu: digitalmenuReducer,
});

export type RootState = ReturnType<typeof rootReducer>;
